const ComparisonOperators = {
  EQ: "equal",
  LT: "lessThan",
  GT: "greaterThan"
};

export default ComparisonOperators;